export enum CashRounding {
  ROUND_TO_05 = "ROUND_TO_05",
  ROUND_TO_10 = "ROUND_TO_10",
  NONE = "NONE",
}

export enum RoundingAlgorithm {
  ROUND_MIDPOINT_DOWN = "ROUND_MIDPOINT_DOWN",
  ROUND_MIDPOINT_UP = "ROUND_MIDPOINT_UP",
}

export type PaymentMethodFormValues = {
  // required if editing
  id?: string;
  // the id of the payment type
  payTypeId: string;
  // a name for the payment method to be displayed to the user
  name: string;
  // enable or disable the payment method
  enabled: boolean;

  // required if adding to a terminal
  terminalIdToAdd?: string;

  // the id paytype in Retailer
  retailerPayTypeId?: string;

  // whether to assign this payment method to the current terminal
  // this is optional, but if true, the payment method will be assigned to the current
  assignToTerminal?: boolean;

  // optional, only required when paytype is "1" (cash)
  rounding?: {
    cashRounding?: CashRounding;
    roundingAlgorithm?: RoundingAlgorithm;
  };
};
